import iconDashboard from '@assets/tools/icons/dashboard-icon.png';

/**
 * @type {Record<string, Overlay>}
 * */
export const dashboards = {
  /**
   * @type {Overlay}
   */
  fundraising: {
    show: true,
    isNew: false,
    isUpdated: false,
    isFeatured: false,
    category: 'dashboards',
    type: 'dashboard',
    name: 'Fundraising Dashboard',
    link: '/dashboards/fundraising',
    thumbnail: iconDashboard,
    imageClass: 'chat-icon',
    shortDescription:
      'Utilize our fundraising dashboard to easily track your fundraising progress.',
    description:
      'Utilize our fundraising dashboard to easily track your fundraising progress.',
    features: [
      '<b>Update: Now displays claimed St. Jude rewards or votes on a poll</b>',
      '<b>Update: Set how many donors to display in your dashboard</b>',
      'Displays total amount raised with your goal',
      'Shows the percentage remaining to complete your goal',
      'Easily see when donors leave a comment, claim a reward or vote in a poll',
      'Tracks your progress toward completing your next milestone',
    ],
    overview: (
      <>
        Effortlessly track your fundraising progress during live streams with
        our intuitive dashboard. It displays claimed rewards, poll votes, donor
        comments, and milestones. Customize the number of donors shown, monitor
        total funds raised, and view the percentage remaining to reach your
        goal.
      </>
    ),
  },
};
